<template>
  <div class="toplist">
    <div class="tableTitle" v-html="sensor.ename+'最近小时均值排名Top10'">
    </div>
    <div class="table">
      <table>
        <thead>
        <tr>
          <td>排名</td>
          <td>监测对象</td>
          <td>监测类型</td>
          <td>
            <span v-html="sensor.ename"></span>
            <span style="font-size: 12px;">(</span>
            <span v-html="sensor.unit" style="font-size: 12px;"></span>
            <span style="font-size: 12px;">)</span>
          </td>
          <td class="td_time">
            <span>更新时间</span>
            <span class="down">
              <Icon type="arrow-down-c"  @click="showTable()" v-if="!isShowTable" class="showIcon"></Icon>
            </span>
            <span class="up">
              <Icon type="arrow-up-c" @click="showTable()" v-if="isShowTable" class="showIcon"></Icon>
            </span>
          </td>
        </tr>
        </thead>
        <tbody v-if="isShowTable">
          <tr v-for="(item, index) in monitorTypeList" v-bind:key="index">
            <td>{{index + 1}}</td>
            <td :title="item.monitorStationName" class="nameObj" style="cursor: pointer" @click="toPage(item.monitorStationId)">{{item.monitorStationName}}</td>
            <td >{{item.monitorAreaTypeName}}</td>
            <td class="td_value"><span :style="'background: ' + item.color">{{item.value}}</span></td>
            <td class="td_time">{{item.time}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userConfig: {},
      sensor: {},
      sensorType: "",
      monitorAreaTypeId: -1,
      districtId: -1,
      monitorTypeList: [],
      isShowTable: true,
      typeList: [],
      sensorValueColor: []
    };
  },
  methods: {
    getSensorValueColor() {
      this.$http
        .get(this.userConfig.apiName + "/v4/sensorValueColor")
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            this.$set(this, "sensorValueColor", result);
            // this.getType();
          }
        });
    },
    getBgColorFromValue(curValue, curName, sensorValueColor) {
      let bgcolor = "";
      if (curValue != 0) {
        let valueColors = [];
        sensorValueColor.forEach(item => {
          if (item.sensor == curName) {
            item.valueColors.forEach(el => {
              if (bgcolor == "") {
                if (curValue * 1 > el.min * 1 || curValue * 1 == el.min * 1) {
                  if (el.max != "") {
                    if (curValue * 1 < el.max * 1) {
                      bgcolor = el.color;
                    }
                  } else {
                    bgcolor = el.color;
                  }
                }
              }
            });
          }
        });
      } else {
        bgcolor = "#c4c4c4";
      }
      return bgcolor;
    },
    getType() {
      this.$http
        .get(this.userConfig.apiName + "/v4/importantSensors")
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data;
            if (result) {
              if (!this.sensorType) {
                this.$set(this, "sensorType", result[0].name);
              }
              result.forEach(el => {
                if (el.name == this.sensorType) {
                  this.$set(this, "sensor", el);
                }
              });
              this.getTopList();
            }
          }
        });
    },
    getTopList() {
      this.$http
        .get(this.userConfig.apiName + "/v4/sampleMonitorAnalyzeTopN", {
          params: {
            sensorType: this.sensorType,
            timeType: 1,
            districtId: this.districtId,
            monitorAreaTypeId: this.monitorAreaTypeId,
            order: "desc",
            page: 0,
            pageSize: 10
          }
        })
        .then(response => {
          if (response.data.code == 0) {
            let result = response.data.data.content;
            // for (let i = 0; i < result.length; i++) {
            //   result[i].color = this.getBgColorFromValue(result[i].value,this.sensorType,this.sensorValueColor);
            // }
            this.$set(this, "monitorTypeList", result);
          }
        });
    },

    // 是否显示top5
    showTable() {
      this.$set(this, "isShowTable", !this.isShowTable);
    },

    showTable() {
      this.$set(this, "isShowTable", !this.isShowTable);
    },
    toPage(id) {
      // this.$set(this, "monitorStationId", potData.monitorStationId);
      window.sessionStorage.setItem("monitorId", id);
      this.$router.push("/detail/history");
    }
  },
  mounted() {
    this.$set(
      this,
      "userConfig",
      JSON.parse(window.sessionStorage.getItem("userConfig"))
    );
    if (this.userConfig) {
      this.getSensorValueColor();
      this.$root.sensorTypeHub.$on("sensorType", sensorType => {
        this.$set(this, "sensorType", sensorType);
        this.getType();
      });
      this.$root.selectModelHub.$on("select", (districts, industry) => {
        this.$set(this, "districtId", districts);
        this.$set(this, "monitorAreaTypeId", industry);
        this.getType();
      });
    }
  }
};
</script>

<style lang="less">
.toplist {
  position: absolute;
  right: 0rem;
  top: 1.2rem;
  opacity: 1;
  width: 8rem;
  color: #fff;

  .showIcon {
    text-align: right;
    cursor: pointer;
    margin-left: 0.2rem;
  }
  .tableTitle {
    font-size: 15px;
    font-weight: bold;
    color: #10d5db;
    background: #091d3d;
  }

  .table {
    width: 100%;
    table {
      table-layout: fixed;
      border-collapse: collapse;
      thead {
        td {
          line-height: 0.4rem;
          font-size: 14px;
          background: #081526;
          opacity: 0.95;
          padding: 10px 5px;
          text-align: center;
          color: #0bfcd7;
        }
      }

      td {
        text-align: center;
        font-size: 12px;
        border: 0px;
        color: #97f0e2;
      }
      .nameObj {
        width: 80px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .td_value {
        color: #fafafa;
        span {
          display: inline-block;
          width: 40px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 5px;
        }
      }
      .td_time {
        width: 160px;
      }
      tr:nth-child(even) {
        background: #081526;
        opacity: 1;
      }
      tr:nth-child(odd) {
        background: #0a1e34;
        opacity: 1;
      }
    }
    .down {
      * {
        transform: rotate(45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
    .up {
      * {
        transform: rotate(45deg);
        vertical-align: sub;
        color: #0bfcd7;
      }
    }
  }
  .more {
    text-align: right;
    border-top: 1px solid #ccc;
  }

  .more button {
    padding: 0.02rem 0.15rem;
    color: #fff;
    background: #10d5db;
    border-radius: 5px;
    text-align: center;
    border: 0rem;
    outline: 0rem;
    cursor: pointer;
    font-size: 0.12rem;
    margin: 0.1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/topList.vue